import { createContext, useContext } from "react";

export const AdminData = createContext({ property: null, reloadProperty: () => {}, badges: {}, reloadBadges: () => {} });
export const useAdminData = () => useContext(AdminData);
